module.exports = __webpack_public_path__ + "img/q.7200e2ee.svg";